import WrappedTelIcon from 'components/elements/icons/WrappedTelIcon'
import CallModal from 'components/elements/modal/CallModal'
import React from 'react'
import styled from 'styled-components'

/**
 * 場所選択マップ、ヘルプボタン
 */
const HelpButton: React.FC = () => {
  return (
    <StyledHelpButton>
      <CallModal isTransitionReAccess>
        <WrappedTelIcon />
      </CallModal>
    </StyledHelpButton>
  )
}

const StyledHelpButton = styled.div`
  position: absolute;
  top: 16px;
  right: 16px;
`

export default React.memo(HelpButton)
